import { ThemeEvents } from '@theme/events';
class LsfImmersiveGallery extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.track = this.querySelector('.lsf-gallery-track');
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.index = 0;
    this.dialog = this.querySelector('dialog');
    const listen = (el, type, fn) => el?.addEventListener(type, fn, { signal });
    listen(this.querySelector('[data-gallery-prev]'), 'click', () => this.go(-1));
    listen(this.querySelector('[data-gallery-next]'), 'click', () => this.go(1));
    listen(this.track, 'keydown', e => {
      if (this.desktop.matches) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.go(e.key === 'ArrowRight' ? 1 : -1); }
    });
    listen(this.track, 'scroll', () => {
      if (this.desktop.matches) return;
      const x = this.track.scrollLeft;
      let closest = 0, distance = Infinity;
      this.slides.forEach((slide, i) => { const d = Math.abs(slide.offsetLeft - this.slides[0].offsetLeft - x); if (d < distance) { distance = d; closest = i; } });
      this.index = closest; this.count();
    });
    this.zoomButtons = [...this.querySelectorAll('[data-zoom-src]')];
    this.zoomImage = this.querySelector('[data-zoom-image]');
    this.zoomIndex = 0;
    this.zoomButtons.forEach((button, index) => listen(button, 'click', () => {
      this.zoomIndex = index;
      this.paintZoom();
      this.dialog.showModal();
    }));
    listen(this.querySelector('[data-zoom-close]'), 'click', () => this.dialog.close());
    listen(this.querySelector('[data-zoom-prev]'), 'click', () => this.moveZoom(-1));
    listen(this.querySelector('[data-zoom-next]'), 'click', () => this.moveZoom(1));
    listen(this.dialog, 'click', e => {
      if (e.target === this.dialog || e.target === this.querySelector('[data-zoom-stage]')) this.dialog.close();
    });
    listen(this.dialog, 'keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        this.moveZoom(e.key === 'ArrowRight' ? 1 : -1);
      }
    });
    listen(this.dialog, 'touchstart', e => {
      this.zoomTouch = e.touches.length === 1 && e.target === this.zoomImage && (window.visualViewport?.scale || 1) <= 1
        ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
    });
    listen(this.dialog, 'touchmove', e => { if (e.touches.length !== 1) this.zoomTouch = null; });
    listen(this.dialog, 'touchcancel', () => { this.zoomTouch = null; });
    listen(this.dialog, 'touchend', e => {
      const start = this.zoomTouch;
      this.zoomTouch = null;
      if (!start || e.touches.length || (window.visualViewport?.scale || 1) > 1) return;
      const end = e.changedTouches[0];
      if (!end) return;
      const dx = end.clientX - start.x, dy = end.clientY - start.y;
      if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.moveZoom(dx < 0 ? 1 : -1);
    });
    listen(this.dialog, 'close', () => { this.zoomTouch = null; });
    listen(this.closest('.shopify-section, dialog'), ThemeEvents.variantUpdated, e => {
      const next = e.detail?.data?.html?.querySelector('lsf-immersive-gallery');
      if (next && (next.dataset.color !== this.dataset.color || next.querySelector('.lsf-gallery-track')?.innerHTML !== this.track.innerHTML)) this.replaceWith(next);
    });
    this.desktop = matchMedia('(min-width: 751px)');
    listen(this.desktop, 'change', () => { this.index = 0; this.paint(); });
    this.paint();
  }
  disconnectedCallback() { this.abort?.abort(); }
  paintZoom() {
    const button = this.zoomButtons[this.zoomIndex];
    if (!button) return;
    this.zoomImage.src = button.dataset.zoomSrc;
    this.zoomImage.alt = button.querySelector('img')?.alt || '';
    this.querySelector('[data-zoom-count]').textContent = `${this.zoomIndex + 1} / ${this.zoomButtons.length}`;
    this.querySelectorAll('[data-zoom-prev], [data-zoom-next]').forEach(control => { control.hidden = this.zoomButtons.length < 2; });
  }
  moveZoom(delta) {
    if (!this.dialog.open || this.zoomButtons.length < 2) return;
    this.zoomIndex = (this.zoomIndex + delta + this.zoomButtons.length) % this.zoomButtons.length;
    this.paintZoom();
  }
  paint() {
    this.slides.forEach(slide => {
      slide.style.order = '';
      slide.inert = false;
    });
    if (this.desktop.matches) this.track.scrollLeft = 0;
    this.count();
  }
  count() {
    const count = this.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
  }
  go(delta) {
    if (!this.slides.length) return;
    const next = (this.index + delta + this.slides.length) % this.slides.length;
    if (this.desktop.matches) { this.index = next; this.paint(); return; }
    this.track.scrollTo({left: this.slides[next].offsetLeft - this.slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
}
if (!customElements.get('lsf-immersive-gallery')) customElements.define('lsf-immersive-gallery', LsfImmersiveGallery);

